import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import LoaneeRequestForm from './LoaneeRequestForm';
import LoaneeLoans from './LoaneeLoans';
import '../styles/Dashboard.css';

function LoaneeDashboard() {
  const { currentUser } = useAuth();
  const [activeTab, setActiveTab] = useState('loans');
  const [showRequestForm, setShowRequestForm] = useState(false);
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLoans();
  }, [currentUser]);

  async function fetchLoans() {
    try {
      const loansQuery = query(
        collection(db, 'loans'),
        where('loaneeId', '==', currentUser.uid)
      );
      const snapshot = await getDocs(loansQuery);
      const loansList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setLoans(loansList);
    } catch (err) {
      console.error('Error fetching loans:', err);
    } finally {
      setLoading(false);
    }
  }

  function handleRequestSuccess() {
    setShowRequestForm(false);
    setActiveTab('loans');
    fetchLoans();
  }

  function calculateTotalOutstanding() {
    return loans.filter(l => l.status === 'active' || l.status === 'pending_acceptance').reduce((sum, loan) => sum + loan.remainingBalance, 0);
  }

  function calculateTotalMonthlyPayment() {
    return loans.filter(l => l.status === 'active').reduce((sum, loan) => sum + loan.monthlyPayment, 0);
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Loanee Dashboard</h1>
        <button
          className="btn btn-primary"
          onClick={() => setShowRequestForm(true)}
        >
          Request New Loan
        </button>
      </div>

      {!loading && (
        <div className="stats-grid" style={{gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', marginBottom: '2rem'}}>
          <div className="stat-card">
            <h3>Total Outstanding</h3>
            <p className="stat-value">${calculateTotalOutstanding().toFixed(2)}</p>
          </div>
          <div className="stat-card">
            <h3>Total Monthly Payment</h3>
            <p className="stat-value">${calculateTotalMonthlyPayment().toFixed(2)}</p>
          </div>
        </div>
      )}

      {showRequestForm && (
        <div className="modal-overlay" onClick={() => setShowRequestForm(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowRequestForm(false)}>×</button>
            <LoaneeRequestForm onSuccess={handleRequestSuccess} />
          </div>
        </div>
      )}

      <div className="tabs">
        <button
          className={`tab ${activeTab === 'loans' ? 'active' : ''}`}
          onClick={() => setActiveTab('loans')}
        >
          My Loans
        </button>
      </div>

      {activeTab === 'loans' && (
        <div className="tab-content">
          <LoaneeLoans />
        </div>
      )}
    </div>
  );
}

export default LoaneeDashboard;
